module.exports = {
    language: {
        name: 'zh'
    },
    banner: {
        more: "滑动浏览更多",
    },
    img: {
        logo: 'logo',
        company: 'company',
        code: 'code',
        totop: 'totop',
    },
    nav: {
        companyName: '浙新四维',
        nav1: "首页",
        nav2: '关于我们',
        nav3: '成功案例',
        nav4: '公司动态',
        nav5: '业务合作',
    },
    headline: {
        title1: '核心技术',
        title2: '应用场景',
        title3: '成功案例',
        title4: '公司简介',
        title5: '核心团队',
        title6: '联系我们',
        title7: '合作伙伴'
    },
    technology: {
        title1: "情感大模型交互，共情能力",
        content1: '捕捉语音中26维情感特征，构建有“共情能力”的交互系统',
        title2: "实时响应",
        content2: '自研大模型毫秒级响应，快速处理用户话语， 通过动态帧率调节算法优化摄像头性能，系统响应延迟控制在500毫秒内（行业平均2-3秒），支持离线语音交互',
        title3: "声纹识别",
        content3: '“真人级”交互对话体验，具备人物声纹识别功能，智能区分不同对话人物，准确识别用户身份',
        title4: "记忆体能力",
        content4: '拥有长期记忆功能，能够记住用户的喜好、习惯、及交流中的关键历史信息',
        title5: "混合计算架构",
        content5: '本地处理低延迟任务（如唤醒词检测），复杂推理（如长文本分析）交由云端大模型完成，平衡功耗与性能',
        title6: "环境降噪",
        content6: '麦克风阵列降噪，确保在复杂环境中仍能保持95％以上的识别准确',
    },
    scenarios: {
        title1: '智慧教育',
        content1: '整合创新教育资源，打造智能课堂系统，为师生提供个性化学习体验和智能教学管理平台(投影仪、显微镜、护眼灯、 识别机 、打印机 、音响)',
        title2: '智慧养老',
        content2: '提供智能养老解决方案，包括远程健康监测、智能看护系统和老年人社交平台等服务(监护、聊天、轮椅、护理床、血糖仪、利氧机、学习机、马桶、防丢器、药盒)',
        title3: '智能玩具',
        content3: '研发智能互动玩具产品，融合AR/VR技术，为儿童提供安全、有趣的智能娱乐体验(毛绒玩具、机器人、电动车、IP形象、谷子经济)',
        title4: '智慧体育',
        content4: '开发专业运动数据分析系统，提供智能训练方案和实时性能监测解决方案(跑步伴侣、体脂秤、智慧跑道、文体AI吉祥物)',
        title5: '智能穿戴',
        content5: '打造新一代智能穿戴设备，集健康监测、运动追踪和生活助手功能于一体(耳机、脖挂风扇、带风扇太阳帽、手表、眼镜、书包)',
        title6: '智能家电',
        content6: '提供全屋智能家电解决方案，实现家居生活的智能化控制和节能管理(空调、风扇、照明、咖啡机、电饭煲)',
    },
    cases: {
        title1: '智能家电产品升级',
        device1: '大电器',
        content1: '通过植入我们自研的AI模组，实现了智能空调全面升级，大幅提升用户体验和产品竞争力',
        msg11: '支持MCP协议，赋予AI使用工具的能力',
        msg12: '用户行为学习，智能场景配置准确率达95%',
        msg13: '远程智能控制，响应时间低于500ms',
        title2: '智能家居风扇方案',
        device2: '智能家电',
        content2: '为风扇产品植入AI控制模组，实现智能调节、远程控制等高级功能，产品销量提升65%',
        msg21: '自然语言+语义理解',
        msg22: '用户满意度提升80%',
        msg23: '多场景联动，支持智能家居生态',
        title3: '智能玩具创新',
        device3: '玩具坦克、小熊布偶',
        content3: '为多款儿童玩具产品植入AI交互芯片，打造会学习、会思考、会陪伴的智能玩具新品类',
        msg31: '智能语音交互，识别准确率达98%',
        msg32: '个性化学习系统，儿童学习兴趣提升75%',
        msg33: '情感交互系统，家长推荐度达92%',
    },
    introduction: {
        p1: '浙新四维是由浙江大学和新加坡管理大学联合培养的博士团队创立的聚焦人工智能创新型企业，团队专注于多模态超拟人AI情感大模型在端侧智能体软硬件开发，以及各类垂类产业应用。',
        p2: '公司重点研发依托以 Emotional Model 为核心的多模态情感模型-小智AI和嵌入式软硬件，其具备多模态识别、个性化情感表达和长期记忆能力，配置MCP可拓展AI能力，集成语音识别、NLP和语音合成技术，实现自然对话。',
        p3: '通过优化交互实时性和拟真度，提供高情商、快速响应的陪伴体验，让科技更有温度。',
        p4: '广泛适用于各种需要人机交互的领域和场景，当前主要应用在体育产业，智能家居、具身机器人产业。浙新四维正致力于将情感大模型计算能力拓展至更多应用场景，让科技不仅智能，更有温度。',
        p5: '精英人才',
        p6: '技术专利',
        p7: '企业客户',
    },
    founders: {
        name1: '秦兵 博士',
        job1: '创始人&实控人',
        titles1: `四川大学物理系,EMBA<br>高级工程师&高级经济师<br>长兴市政协委员<br>长兴博泰电子集团 董事长`,
        name2: `谭雪 博士`,
        job2: `联合创始人&CEO`,
        titles2: `前世界500强外企高管<br>20年FMCG行业经验<br>负责公司整体运营`,
        name3: `蔡美行`,
        job3: `研发负责人`,
        titles3: `四川大学 电子信息<br>拥有13项国内授权专利<br>2项美国专利<br>深耕智能设备AIOT`,
        name4: `黄冠（虾哥）`,
        job4: `首席战略顾问`,
        titles4: `十方融海 董事长<br>华南理工大学计算机系<br>2022年度深圳软件行业“领域专家”<br>2024中国人工智能卓越人物奖<br>提供多模态大模型技术支持`,
    },
    contactUs: {
        title1: "公司信息",
        content11: '地址',
        content12: '电话',
        content13: '邮箱',
        content14: '浙江省杭州市余杭区浙江大学校友企业总部经济园二期C5幢904',
        content15: '（微信同号）',
        title2: '政策服务',
        content21: "版权声明",
        content22: "侵权投诉",
        content23: "用户协议",
        content24: "隐私协议",
        content25: "售后服务",
        content26: "关于我们",
        title3: '微信公众号',
        title4: '微信小程序',
        title5: '浙新四维科技有限公司',
        title6: '保留所有权利',
        title7: '浙ICP备2025182597号-1',
        title8: '关注我们'
    },
    bannerTxt: {
        title1: "最新动态",
        msg1: '展示公司最新活动、新闻、荣誉',
        title2: "联系我们",
        msg2: '告诉我们您的需求，专业顾问会尽快与您取得联系',
    },
    news: {
        title1: `浙新四维 × 灵境智源达成战略合作，携手推进国产具身智能新突破`,
        date1: `2025年10月27日 16:24`,
        title2: `重磅：浙新四维获种子轮融资，全面布局AI全产业链`,
        date2: `2025年10月14日 11:15`,
        title3: `「浙新四维」亮相浙江省第六届户外运动大会`,
        date3: `2025年09月17日 17:19`,
        title4: `浙新四维闪耀2025外滩大会：以AI创新赋能产业变革`,
        date4: `2025年09月16日 16:19`,
        title5: `“浙小体”和“宇大嘴”将在浙江城市篮球联赛争霸赛浙BA上亮相`,
        date5: `2025年08月13日 15:22`,
    },
}